import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkConfig } from '../../../../../app/providers/StoreProvider';
import { extractErrorMessage } from '../../../../../shared/lib/extractErrorMessage/extractErrorMessage';
import {
  ApiErrorResponse,
  ApiSuccessResponse,
} from '../../../../../shared/types/apiResponse';
import { CartItemDto } from '../../types/cart';
import { AxiosError } from 'axios';

export interface AddCartItemInput {
  cartId: string;
  dto: CartItemDto;
}

interface AddToCartData {
  total: number;
  itemCount: number;
}

export const addToCart = createAsyncThunk<
  ApiSuccessResponse<AddToCartData>,
  AddCartItemInput,
  ThunkConfig<string>
>('@@cart/addItem', async (addCartItemInput, thunkAPI) => {
  const { extra, rejectWithValue } = thunkAPI;
  const { cartId, dto } = addCartItemInput;

  try {
    const response = await extra.api.post(`/cart/${cartId}`, dto);

    return response.data;
  } catch (error) {
    return rejectWithValue(extractErrorMessage(error as AxiosError | ApiErrorResponse));
  }
});
